import type { PublicId } from 'flow/store/engine/types';
import type { MergeDiffResult } from './types';

export function getIsMergeImpacted(
  mergeDiff: MergeDiffResult,
  publicId: PublicId,
) {
  const { added, modified } = mergeDiff;
  return added.has(publicId) || modified.has(publicId);
}
